
import { defineComponent } from 'vue'
import AppToast from './AppToast.vue'
import { store } from '@/store'

export default defineComponent({
  name: 'AppToasts',
  components: { AppToast },
  setup() {
    store.global.mutate(state => state.toasts = [])
    const toasts = store.global.get(state => state.toasts)

    return { store, toasts }
  }
})
